import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { deleteUser } from '../api/users.api';

export function useDeleteUser() {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (id: string) => deleteUser(id),
    onSuccess: () => {
      void refreshRelatedData('user');
      toast.success('User deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete user');
    },
  });
}
